import { Component, inject, Input } from '@angular/core';
import { RapidReviewDiagnosisResponse } from '@gandalf/model/rapid-review-diagnosis-response';
import { DATE_FORMATS } from '@shared/constants/date-format.constants';
import { GridUtil, GridUtilService, RevColDef } from 'majora';
import { RapidReviewCarePlanItemResponse } from '@gandalf/model/rapid-review-care-plan-item-response';
import { AgGridModule } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { AgAutoFitColumnsDirective } from '@shared/directives/grid/ag-auto-fit-columns/ag-auto-fit-columns.directive';
import { AgGridNoFilteredRowsDirective } from 'morgana';
import { AgGridTooltipDirective } from '@shared/directives/grid/tooltip/ag-grid-tooltip.directive';

@Component({
	selector: 'pms-rapid-review-diagnosis',
	imports: [
		AgGridModule,
		CommonModule,
		AgAutoFitColumnsDirective,
		AgGridNoFilteredRowsDirective,
		AgGridTooltipDirective,
	],
	templateUrl: './rapid-review-diagnosis.component.html',
})
export class RapidReviewDiagnosisComponent {
	private gridUtilService = inject(GridUtilService);

	@Input({required: true})
	diagnosis: RapidReviewDiagnosisResponse;

	dateFormat = DATE_FORMATS.MM_DD_YYYY;

	gridColumns: RevColDef<RapidReviewCarePlanItemResponse>[] = [
		GridUtil.buildColumn('CPI Type', 'category'),
		this.gridUtilService.buildDateColumn('Start Date', 'startDate'),
		GridUtil.buildFlexColumn('Description', 'description'),
	];
}
